export var FileExtensionEnum;
(function (FileExtensionEnum) {
    FileExtensionEnum["jpg"] = "jpg";
    FileExtensionEnum["png"] = "png";
    FileExtensionEnum["svg"] = "svg";
    FileExtensionEnum["jpeg"] = "jpeg";
    FileExtensionEnum["pdf"] = "pdf";
    FileExtensionEnum["xlsx"] = "xlsx";
    FileExtensionEnum["docx"] = "docx";
    FileExtensionEnum["gif"] = "gif";
    FileExtensionEnum["heic"] = "heic";
})(FileExtensionEnum || (FileExtensionEnum = {}));
//# sourceMappingURL=file-extension.enum.js.map